import React from "react";
import { Field, FieldArray } from "redux-form";
import { renderDollar } from "../../../../../../Utils/renderField/renderField";
import { months as meses } from "../../../../../../Utils/months";
import "./ModalForm.css";
const TableRow = ({ system, index, fields }) => {
    return (
        <tr key={`fila-${index}`}>
            {meses.map((mes) => (
                <td key={mes} className="text-center">
                    <Field
                        name={`${system}.${mes}`}
                        type="text"
                        component={renderDollar}
                        className="form-control"
                        placeholder="$0.00"
                        decimalScale={4}
                    />
                </td>
            ))}
        </tr>
    );
};

const SimpleDollarTable = ({ fields }) => {
    return (
        <div className="tabla-wrapper">
            <div className="scroll-container">
                <table className="custom-table">
                    <thead>
                        <tr>
                            {meses.map((_, index) => (
                                <th key={index}>
                                    {index + 1}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((system, index) => (
                            <TableRow
                                key={index}
                                system={system}
                                index={index}
                                fields={fields}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
const ModalForm = (props) => {
    return (
        <div className="modal-form-wrapper">
            <div className="modal-form-inner">
                <FieldArray
                    name="sales_data"
                    component={SimpleDollarTable}
                    props={props}
                />
            </div>
        </div>
    );
};

export default ModalForm;
